import { render } from "./NewContentDialog.vue?vue&type=template&id=443b95a1&scoped=true"
import script from "./NewContentDialog.vue?vue&type=script&lang=js"
export * from "./NewContentDialog.vue?vue&type=script&lang=js"

import "./NewContentDialog.vue?vue&type=style&index=0&id=443b95a1&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443b95a1"]])

export default __exports__